import vueform_de from '@vueform/vueform/locales/de'
import vueform_en from '@vueform/vueform/locales/en'
import festiware_de from './locales/de';
import festiware_en from './locales/en';
import vueform from '@vueform/vueform/dist/vueform'
import { defineConfig } from '@vueform/vueform'
import MaskPlugin from '@vueform/plugin-mask'
import {
    RepeaterPlugin,
    localizedButtonsPlugin,
    staticSelectsPlugin,
    filesPlugin,
    selfiePlugin,
    datesPlugin,
    dateTextPlugin,
    signaturePlugin,
    phoneValidator,
    emailValidator,
    dateTextValidator,
    dateValidator
} from "./customElements/plugins";
import EventsElement from "./customElements/EventsElement.vue";
import NewPhoneElement from "./customElements/PhoneElement.vue";

import FormTabs from './customElements/FormTabs.vue';
import FormTab from './customElements/FormTab.vue';
import tabsPlugin from './customElements/tabsPlugin';
import FormSteps from './customElements/FormSteps.vue';
import FormStep from './customElements/FormStep.vue';
import stepsPlugin from './customElements/stepsPlugin';

import '@vueform/vueform/dist/vueform.css';

function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
}

function mergeDeep(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, { [key]: {} });
                mergeDeep(target[key], source[key]);
            } else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }
    return mergeDeep(target, ...sources);
}

const de = mergeDeep(vueform_de, festiware_de);
const en = mergeDeep(vueform_en, festiware_en);
// phoneNumber validation messages are now in locales/de.js and locales/en.js

export default defineConfig({
    showRequired: ['label', 'placeholder', 'floating'],
    validateOn: 'step',
    displayMessages: true,
    // DOMPurify (via $vueform.sanitize) drops `target` by default, which strips
    // target="_blank" from admin-authored links in field help texts / html blocks.
    // ADD_ATTR is additive: it clones the default allowlist and only adds `target`.
    sanitizeOptions: { ADD_ATTR: ['target'] },
    theme: {
        ...vueform,
        templates: {
            ...vueform.templates,
            FormTabs,
            FormTab,
            FormSteps,
            FormStep,
        },
    },
    locales: { de, en },
    locale: 'de',
    elements: [EventsElement, NewPhoneElement],
    rules: {
        phoneNumber: phoneValidator,
        email: emailValidator,
        dateText: dateTextValidator,
        // Overrides Vueform's built-in rule of the same name (Factory.rules merges
        // config rules over the service defaults) — see dateValidator in plugins.js.
        date: dateValidator
    },
    plugins: [
        RepeaterPlugin, localizedButtonsPlugin, staticSelectsPlugin, filesPlugin, selfiePlugin, signaturePlugin, datesPlugin, tabsPlugin, stepsPlugin,
        // MaskPlugin was vendored (MIT) but left disabled when the phone field went to
        // intl-tel-input instead. It is inert unless an element carries a `mask` prop
        // (`if (!mask) return component` in its setup), so enabling it changes nothing
        // for existing text fields — it only backs the date-as-text-input variant.
        // dateTextPlugin MUST stay after MaskPlugin — see its comment in plugins.js.
        MaskPlugin, dateTextPlugin
    ],
    endpoints: {
        url: false,
        removeFile: false,
        uploadTempFile: async (file, el$) => {
            const result = await el$.form$.providers.doOctoberRequest('onSubmitFile', {file}, true);
            if (!result || !result.tmp) {
                throw new Error(el$.form$.translations.festiware?.upload_failed || 'Upload failed');
            }
            return result;
        },
        removeTempFile: (file, el$) => el$.form$.providers.doOctoberRequest('onDeleteFile', {id: el$.value}),
    }
})

